var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2175 12.28C2.9275 11.987 2.9275 11.513 3.2175 11.22L6.2175 8.22C6.5075 7.927 6.9875 7.927 7.2775 8.22C7.5675 8.513 7.5675 8.987 7.2775 9.28L5.5575 11H13.7475C14.1575 11 14.4975 11.336 14.4975 11.75C14.4975 12.164 14.1575 12.5 13.7475 12.5H5.5575L7.2775 14.22C7.5675 14.513 7.5675 14.987 7.2775 15.28C6.9875 15.573 6.5075 15.573 6.2175 15.28L3.2175 12.28ZM12.9975 22.75C12.9975 22.336 13.3375 22 13.7475 22H17.7475C18.4375 22 18.9975 21.44 18.9975 20.75V2.75C18.9975 2.06 18.4375 1.5 17.7475 1.5H13.7475C13.3375 1.5 12.9975 1.164 12.9975 0.75C12.9975 0.336 13.3375 0 13.7475 0H17.7475C19.2675 0 20.4975 1.231 20.4975 2.75V20.75C20.4975 22.269 19.2675 23.5 17.7475 23.5H13.7475C13.3375 23.5 12.9975 23.164 12.9975 22.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSignout);
export default __webpack_public_path__ + "static/media/ico-signout.46616a87.svg";
export { ForwardRef as ReactComponent };